/* istanbul ignore file */

/* eslint-disable react/require-default-props */
import React from 'react';
import { node, object, array } from 'prop-types';
import Ellipsis from './Ellipsis';
import Heading from '../heading';
import IconFacebook from './assets/IconFacebook';
import IconYoutube from './assets/IconYoutube';
import IconTwitter from './assets/IconTwitter';
import IconEllipsis from './assets/IconEllipsis';
import IconNews from './assets/IconNews';
import IconPhone from './assets/IconPhone';
import IconLinkedIn from './assets/IconLinkedIn';
import IconPinterest from './assets/IconPinterest';
import IconInstagram from './assets/IconInstagram';

var WrapperTop = function WrapperTop(_ref) {
  var toggleHospitalsAndMedicalGroups = _ref.toggleHospitalsAndMedicalGroups,
      patientSelfServiceLinks = _ref.patientSelfServiceLinks,
      hospitalsAndMedicalGroups = _ref.hospitalsAndMedicalGroups,
      toggleEmployeesAndPartners = _ref.toggleEmployeesAndPartners,
      employeesAndPartners = _ref.employeesAndPartners,
      companyInformation = _ref.companyInformation,
      sideDrawer = _ref.sideDrawer;
  var scl = 'scl-';
  var colorPlum = '#9e8f93';
  var logoSharp = 'https://images.sharp.com/com/logos/logo.png';
  var urlFacebook = '//www.facebook.com/sharphealthcare';
  var urlTwitter = '//www.twitter.com/sharphealthcare';
  var urlYouTube = '//www.youtube.com/sharphealthcare';
  var urlSharpHealthNews = '/health-news/';
  var urlPhone = 'tel:+18008274277';
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(scl, "wrapper-top"),
    "data-test-id": "wrapper-top"
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(scl, "container")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(scl, "row")
  }, /*#__PURE__*/React.createElement("div", {
    className: "scl-col scl-col-1"
  }, /*#__PURE__*/React.createElement(Heading, {
    color: colorPlum,
    variant: 6
  }, "Patient Self-Service"), /*#__PURE__*/React.createElement("ul", {
    className: "unordered-list",
    "data-test-id": "patientSelfServiceLinks"
  }, patientSelfServiceLinks)), /*#__PURE__*/React.createElement("div", {
    className: "scl-col scl-col-2 mobile toggleHospitalsAndMedicalGroups"
  }, toggleHospitalsAndMedicalGroups), /*#__PURE__*/React.createElement("div", {
    className: "scl-col scl-col-2 large"
  }, /*#__PURE__*/React.createElement(Heading, {
    color: colorPlum,
    variant: 6
  }, "San Diego Hospitals and Medical Groups"), /*#__PURE__*/React.createElement("ul", {
    className: "unordered-list",
    "data-test-id": "hospitalsAndMedicalGroups"
  }, hospitalsAndMedicalGroups)), /*#__PURE__*/React.createElement("div", {
    className: "scl-col scl-col-3 mobile toggleEmployeesAndPartners"
  }, toggleEmployeesAndPartners), /*#__PURE__*/React.createElement("div", {
    className: "scl-col scl-col-3 large"
  }, /*#__PURE__*/React.createElement(Heading, {
    color: colorPlum,
    variant: 6
  }, "Employees and Partners"), /*#__PURE__*/React.createElement("ul", {
    className: "unordered-list",
    "data-test-id": "employeesAndPartners"
  }, employeesAndPartners)), /*#__PURE__*/React.createElement("div", {
    className: "scl-col scl-col-4"
  }, /*#__PURE__*/React.createElement(Heading, {
    color: colorPlum,
    variant: 6
  }, "Company Information"), companyInformation, sideDrawer), /*#__PURE__*/React.createElement("div", {
    className: "scl-col scl-col-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "block block-1"
  }, /*#__PURE__*/React.createElement("a", {
    className: "anchor",
    target: "_self",
    href: "/",
    "aria-label": "Return to the Sharp Healthcare homepage"
  }, /*#__PURE__*/React.createElement("img", {
    className: "image",
    src: logoSharp,
    alt: "Sharp logo"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "block block-2"
  }, /*#__PURE__*/React.createElement("a", {
    className: "anchor facebook",
    target: "_target",
    href: urlFacebook,
    "aria-label": "Sharp Healthcare's Facebook page"
  }, /*#__PURE__*/React.createElement(IconFacebook, null))), /*#__PURE__*/React.createElement("div", {
    className: "block block-3"
  }, /*#__PURE__*/React.createElement("a", {
    className: "anchor twitter",
    target: "_target",
    href: urlTwitter,
    "aria-label": "Sharp Healthcare's Twitter page"
  }, /*#__PURE__*/React.createElement(IconTwitter, null))), /*#__PURE__*/React.createElement("div", {
    className: "block block-4"
  }, /*#__PURE__*/React.createElement("a", {
    className: "anchor youtube",
    target: "_target",
    href: urlYouTube,
    "aria-label": "Sharp Healthcare's YouTube page"
  }, /*#__PURE__*/React.createElement(IconYoutube, null))), /*#__PURE__*/React.createElement("div", {
    className: "block block-5"
  }, /*#__PURE__*/React.createElement(Ellipsis, {
    icon: /*#__PURE__*/React.createElement(IconEllipsis, null)
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("a", {
    className: "anchor",
    target: "_blank",
    href: "//www.instagram.com/sharphealthcare",
    "aria-label": "Sharp Healthcare's Instagram page"
  }, /*#__PURE__*/React.createElement(IconInstagram, null)), /*#__PURE__*/React.createElement("a", {
    className: "anchor",
    target: "_blank",
    href: "//www.pinterest.com/sharphealthcare",
    "aria-label": "Sharp Healthcare's Pinterest page"
  }, /*#__PURE__*/React.createElement(IconPinterest, null)), /*#__PURE__*/React.createElement("a", {
    className: "anchor",
    target: "_blank",
    href: "//www.linkedin.com/company/sharp-healthcare",
    "aria-label": "Sharp Healthcare's LinkedIn page"
  }, /*#__PURE__*/React.createElement(IconLinkedIn, null))))), /*#__PURE__*/React.createElement("div", {
    className: "block block-6"
  }, /*#__PURE__*/React.createElement("a", {
    className: "anchor news",
    target: "_self",
    href: urlSharpHealthNews,
    "aria-label": "Sharp Healthcare's Health News page"
  }, /*#__PURE__*/React.createElement(IconNews, null), /*#__PURE__*/React.createElement("p", {
    className: "paragraph"
  }, "Sharp Health News"))), /*#__PURE__*/React.createElement("div", {
    className: "block block-7"
  }, /*#__PURE__*/React.createElement("a", {
    className: "anchor phone",
    target: "_self",
    href: urlPhone,
    "aria-label": "Call Sharp Healthcare"
  }, /*#__PURE__*/React.createElement(IconPhone, null), /*#__PURE__*/React.createElement("p", {
    className: "paragraph"
  }, "1-800-827-4277")))))));
};

WrapperTop.propTypes = {
  /**
   * togglePatientSelfService mapped object.
   */
  togglePatientSelfService: object,

  /**
   * patientSelfServiceLinks mapped array.
   */
  patientSelfServiceLinks: array,

  /**
   * hospitalsAndMedicalGroups mapped array.
   */
  hospitalsAndMedicalGroups: array,

  /**
   * toggleEmployeesAndPartners mapped object.
   */
  toggleEmployeesAndPartners: object,

  /**
   * employeesAndPartners mapped array.
   */
  employeesAndPartners: array,

  /**
   * companyInformation mapped array.
   */
  companyInformation: object,

  /**
   * sideDrawer component and content
   */
  sideDrawer: node
};
export default WrapperTop;